const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function start(detail, htmlDt, htmlFc) {  //console.log('Menu Type 2 -> ', detail)

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc)
  }

  detail.html = menuElem

  detail.act = 'show'
  menu.start(detail)

}

const menuBody = {

  tabMenu: [
    {
      text: "",
      svg: `sync`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Other Expense"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"otherexpense", "elem":"page", "id":"otherexpense-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

    { text: "line", start: function () { } }, //////////////line

    {
      text: "",
      svg: `account`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Accounts"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"accounts", "elem":"page", "id":"accounts-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

  ],

  trMenu: [

    {
      text: '',
      svg: 'eye',
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = 'View/Edit'        //language.start('inProgress')     
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "act":"selectOne",  "entity":"sentpayment", "dbid": ${detail.dbid} }
           ]}'`

      }
    },

    {
      text: '',
      svg: 'docs',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Print Sent Payment'
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "entity":"sentpayment", "act":"reportPdf", "id":"${detail.dbid}", "report":"sentpayment-one"}

        ]}'`

      }

    },

    {
      text: '',
      svg: 'receipt',
      class: ``,
      dataDetail: '',

      start: function (detail) {
        this.text = 'Print Check'
        const checkGenerationActive = detail.checkGenerationActive === 'true' ? 'true' : ''
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"},
                              {"dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "entity":"sentpayment", "act":"reportPdf", "id":"${detail.dbid}", "report":"sentpayment-check", "checkGenerationActive":"${checkGenerationActive}"}
        ]}'`
      }
    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,

      start: function (detail) {

        this.text = 'Delete'
        this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"sentpayment", "elem":"fullcont", "act":"deleteEntity", "entity":"sentpayment", "dbid":["${detail.dbid}"] } 
           ]}'`

      }
    },
  ],

  tableOptions: [

    {
      text: '',
      svg: 'receipt',
      class: ``,
      dataDetail: ``,

      start: function (detail, htmlDt) {
        // Se usa el mismo flujo de seleccion multiple que la entidad Areas.
        const ids = dtHandler.getTrChecked(htmlDt)

        if (ids.length > 0) {
          this.class = ``
          this.text = `Print Checks (${ids.length})`
          this.dataDetail = `data-detail='{
                              "click": [
                                {"dest":"ripple"},
                                {"dest":"menu", "act":"hide"},
                                {"dest":"sentpayment", "elem":"quickform", "act":"preparePrint", "dbid":[${ids}]}
                              ]}'`
        } else {
          this.class = `disabled`
          this.text = `Print Checks`
          this.dataDetail = ``
        }
      }
    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: ``,

      start: function (detail, htmlDt) {  //console.log('startXXXXXXXXXXXXX')

        const ids = dtHandler.getTrChecked(htmlDt)

        //if exist one check
        if (ids.length > 0) {
          this.class = ``
          this.text = `Delete All (${ids.length})`
          this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"sentpayment", "elem":"fullcont", "act":"deleteEntity", "entity":"sentpayment",  "dbid":[${ids}]} ]}'`
        } else {
          this.class = `disabled`
          this.text = `Delete All`
          this.dataDetail = ''
        }/*if*/

      }/**/
    },
  ],

  fullcontOptions: [

    {
      text: '',
      svg: 'edit',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        this.text = `Edit`
        this.dataDetail = `data-detail='{
                                   "click": [
                                      {"dest":"ripple" },
                                      {"dest":"menu", "act":"hide"},
                                      {"dest":"sentpayment", "elem":"fullcont",  "id":"sentpayment-fullcont", "act":"prepareEdit" }  ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'docs',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        this.class = ``
        this.text = `Print Sent Payment`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "entity":"sentpayment", "act":"reportPdf", "id":"", "report":"sentpayment-one"} ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'receipt',
      class: ``,
      dataDetail: ``,

      start: function () {
        this.class = ``
        this.text = `Print Check`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "entity":"sentpayment", "act":"reportPdf", "id":"", "report":"sentpayment-check"} ]}'`
      }
    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``, //same name as the title test

      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')

        //if exist one check
        this.class = ``
        this.text = `Delete `
        this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"sentpayment", "elem":"fullcont", "act":"deleteEntity", "entity":"sentpayment",  "dbid":[${dbid}]} ]}'`

      }/**/
    },
  ],

}/*menuBody*/
